<template>
  <div>
    <headers />

    <!-- <div class="breadcrumb" :key="itemKey">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ "考试中心" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <div class="content">
      <div class="contentBox">
        <div class="contentBoxTitle">{{ infoData.name }}</div>
        <div class="contentBoxContent">
          <div class="contentHeader">
            <div class="left">
              <span>答题进度</span>
              <span class="leftProgress">{{ index + 1 }}</span>
              <span class="leftNoProgress">/{{ listData.length }}</span>
            </div>

            <div class="right" v-if="!situationId">
              <img src="../../assets/images/timeIcon.png" alt="" />
              <span class="rightText">剩余时间</span>
              <span class="rightTime">{{ formattedTime }}</span>
            </div>
          </div>
        </div>
        <!-- jindutiao -->
        <div class="line">
          <div :style="{ width: progressWidth + '%' }"></div>
        </div>
      </div>
      <!-- timu -->

      <div class="contentList" v-if="listData.length">
        <div class="contentListTitle">
          {{ index + 1 + ". " }}{{ listData[index].title }}
        </div>
        <div class="contentListType">
          {{ listData[index].type == 1 ? "单选题" : "多选题" }}
        </div>

        <div class="contentListBox">
          <div
            class="contentListBoxItem"
            v-for="(item, index) in listData[index].children"
            :key="index"
            @click="!situationId && handleSelect(item)"
            :style="{ cursor: situationId ? 'default' : 'pointer' }"
          >
            <div
              :class="[item.checked ? 'active' : '', 'contentListBoxItemCheck']"
            >
              <img
                v-if="item.checked"
                src="../../assets/images/checked.png"
                alt=""
              />
            </div>
            <div
              :class="[item.checked ? 'active' : '', 'contentListBoxItemText']"
            >
              {{ item.key + ". " }}{{ item.content }}
            </div>
          </div>
        </div>
        <div v-if="situationId">正确答案:{{ listData[index].realAnswer }}</div>

        <div class="contentListFooter">
          <div class="pre" v-if="index !== 0" @click="handlePrev">上一题</div>
          <div
            v-if="!situationId"
            class="next"
            :style="{ width: index === 0 ? '300px' : '200px' }"
            @click="handleNext"
          >
            {{ index === listData.length - 1 ? "交卷" : "下一题" }}
          </div>
          <div
            v-else
            class="next"
            :style="{ width: index === 0 ? '300px' : '200px' }"
            @click="handleNextView"
          >
            下一题
          </div>
        </div>
      </div>
    </div>

    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import search from "@/components/search.vue";

import { examQuestion, examCommit, examSituation } from "@/api/examination";
export default {
  name: "news",
  components: {
    headers,
    footers,
    search,
  },
  data() {
    return {
      index: 0,
      listData: [],
      itemKey: Math.random(),
      endTime: 0,
      timer: null,
      formattedTime: "00:00:00",
      id: "",
      startTime: 0,
      progressWidth: 0,
      disabled: false,
      infoData: {},
      situationId: "", //查看答题情况id
      situationIndex: "", //当前查看第几题
    };
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  created() {
    // 获取路由参数，如果有传入试卷id等信息可在此处获取
    this.situationId = this.$route.query.situationId || "";
    this.situationIndex = this.$route.query.situationIndex || "";
    this.situationId && this.getSituation();
    !this.situationId && this.examQuestion();
  },
  mounted() {},
  methods: {
    // 格式化时间
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${minutes.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
    },

    // 开始倒计时
    startCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        if (this.endTime <= 0) {
          clearInterval(this.timer);
          this.handleSubmit(false); // 时间到自动交卷
          return;
        }
        this.endTime--;
        this.formattedTime = this.formatTime(this.endTime);
      }, 1000);
    },

    // 更新进度条
    updateProgress() {
      const targetWidth = ((this.index + 1) / this.listData.length) * 100;
      // 使用 requestAnimationFrame 实现平滑动画
      const animate = () => {
        if (this.progressWidth < targetWidth) {
          this.progressWidth += (targetWidth - this.progressWidth) * 0.1;
          if (targetWidth - this.progressWidth > 0.1) {
            requestAnimationFrame(animate);
          } else {
            this.progressWidth = targetWidth;
          }
        }
      };
      requestAnimationFrame(animate);
    },

    async examQuestion() {
      try {
        const res = await examQuestion({});
        if (res.code == 200) {
          this.infoData = res.data;
          res.data.details.map((item) => {
            item.children = Object.entries(item.titleOptionJson).map(
              ([k, v]) => ({
                key: k,
                content: v,
                checked: false,
              })
            );
          });
          this.id = res.data.id;
          this.listData = res.data.details;

          // 只有在非查看模式下才启动倒计时
          if (!this.situationId) {
            this.endTime = res.data.examTime * 60;
            this.formattedTime = this.formatTime(this.endTime);
            this.startTime = Date.now();
            this.startCountdown();
          }

          this.updateProgress();
        }
      } catch (error) {}
    },
    // 选择答案
    handleSelect(item) {
      const currentQuestion = this.listData[this.index];
      if (currentQuestion.type === 1) {
        // 单选题逻辑
        currentQuestion.children.forEach((child) => {
          child.checked = false;
        });
        item.checked = true;
      } else {
        // 多选题逻辑
        item.checked = !item.checked;
      }
    },

    // 上一题
    handlePrev() {
      if (this.index > 0) {
        this.index--;
        this.updateProgress();
      }
    },

    // 下一题或交卷
    handleNext() {
      if (this.index === this.listData.length - 1) {
        // 交卷逻辑
        this.handleSubmit(true);
      } else {
        const is = this.listData[this.index].children.some(
          (item) => item.checked
        );
        if (!is) return this.$message.warning(`请选择一个选项`);
        this.index++;
        this.updateProgress();
      }
    },

    // 查看模式下的下一题（不需要验证是否选择）
    handleNextView() {
      if (this.index < this.listData.length - 1) {
        this.index++;
        this.updateProgress();
      }
    },

    // 交卷
    async handleSubmit(isVad) {
      // 检查是否所有题目都已作答
      const unanswered = this.listData.findIndex((question) => {
        return !question.children.some((child) => child.checked);
      });

      if (isVad && unanswered !== -1) {
        this.$message.warning(
          `第${unanswered + 1}题还未作答，请完成所有题目后再交卷`
        );
        return;
      }

      let questions = [];
      // 计算得分
      this.listData.forEach((question) => {
        const selectedAnswers = question.children.filter(
          (child) => child.checked
        );
        questions.push({
          id: question.id,
          answer: selectedAnswers.map((item) => item.key).join(""),
        });
      });

      if (this.disabled) return;
      this.disabled = true;
      try {
        const res = await examCommit({
          id: this.id,
          questions,
        });

        // 清除定时器
        if (this.timer) {
          clearInterval(this.timer);
        }
        // 使用 replace 替换当前页面，这样用户点击返回时不会回到考试页面
        this.$router.replace({
          name: "examinationResult",
          query: {
            id: this.id,
            useTime: res.data.useTime,
            state: res.data.state,
            totalScore: res.data.totalScore,
            score: res.data.score,
          },
        });
      } catch (error) {
        this.$message.error("提交失败，请重试");
      } finally {
        setTimeout(() => {
          this.disabled = false;
        }, 2000);
      }
    },
    //查看答题情况
    getSituation() {
      console.log(this.situationId, "this.situationId");

      examSituation({
        id: this.situationId,
      }).then((res) => {
        if (res.code == 200) {
          res.data.results.map((item) => {
            // item.answer is a string like 'A,B,C'. Convert to array for checking.
            const answerArr = item.answer ? item.answer.split("") : [];
            item.children = Object.entries(item.titleOptionJson).map(
              ([k, v]) => ({
                key: k,
                content: v,
                checked: answerArr.includes(k),
              })
            );
          });
          this.listData = res.data.results;
          this.infoData = res.data;

          // 如果有situationIndex参数，直接跳转到指定题目
          if (this.situationIndex) {
            // situationIndex是从1开始的，所以需要减1转换为数组索引
            const targetIndex = parseInt(this.situationIndex) - 1;
            if (targetIndex >= 0 && targetIndex < this.listData.length) {
              this.index = targetIndex;
              this.updateProgress();
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 1400px;
  margin: 0 auto;
  box-sizing: border-box;
  padding-left: 6px;
  box-sizing: border-box;
  padding-top: 30px;
  min-height: 400px;
  display: flex;
  flex-wrap: wrap;
  .contentBox {
    width: 100%;
    padding: 30px 50px;
    height: 183px;
    margin-bottom: 30px;
    box-sizing: border-box;
    background: #fff;

    .line {
      width: 1300px;
      height: 16px;
      background: rgba(0, 216, 195, 0.12);
      border-radius: 8px;
      margin-top: 8px;
      div {
        transition: all 0.3 linear;
        border-radius: 8px;
        background: #00d8c3;
        height: 100%;
      }
    }
  }
  .contentBoxTitle {
    font-size: 26px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 25px;
  }

  .contentBoxContent {
    .contentHeader {
      display: flex;
      align-items: center;
      .left {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #829199;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        margin-right: 78px;
        .leftNoProgress {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #00161a;
          line-height: 22px;
          font-style: normal;
        }
        .leftProgress {
          margin: 0 4px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 26px;
          color: #00161a;
          line-height: 37px;
          text-align: left;
          font-style: normal;
        }
      }
      .right {
        img {
          width: 20px;
          height: 20px;
          vertical-align: text-top;
        }
        .rightText {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #829199;
          line-height: 22px;
          text-align: left;
          font-style: normal;
          margin: 0 4px;
        }
        .rightTime {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 26px;
          color: #00161a;
          line-height: 37px;
          text-align: left;
          font-style: normal;
        }
      }
    }
  }
}

.contentList {
  width: 100%;
  background: #fff;
  min-height: 490px;
  padding: 40px 50px;
  box-sizing: border-box;
  margin-bottom: 30px;
  .contentListFooter {
    display: flex;
    align-items: center;
    margin-top: 60px;
    div {
      width: 200px;
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      border-radius: 4px;
      cursor: pointer;
    }
    .pre {
      background: #ffffff;
      border: 1px solid #00d8c3;
      color: #00d8c3;
      margin-right: 15px;
    }

    .next {
      background: #00d8c3;
      color: #ffffff;
    }
  }

  .contentListTitle {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #00161a;
    line-height: 28px;
    text-align: left;
    font-style: normal;
  }
  .contentListType {
    width: 68px;
    height: 26px;
    background: #00d8c3;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px 0 35px;
  }

  .contentListBox {
    margin-top: 35px;
    .contentListBoxItem {
      cursor: pointer;
      display: flex;
      align-content: center;
      margin-bottom: 20px;
      .contentListBoxItemText {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #2c3041;
        font-style: normal;
        border: none !important;
      }
      .contentListBoxItemCheck {
        width: 22px;
        height: 22px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #b8c5cc;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 14px;
          height: 14px;
        }
      }

      .active {
        border: 1px solid #00d8c3;
        color: #00d8c3;
      }
    }
  }
}
</style>
